<template>
<div>
  <div class="filters-container">
    <b-taglist>
      <b-tag v-for="(f, index) in allFilters" :key="`${f.key}-${index}`" rounded closable
        @close="removeFilter(f.key, f.value)">
        {{f.label}}
      </b-tag>
    </b-taglist>
    <button @click="showModal" class="button is-inverted is-rounded">
      <img :src="`${$publicPath()}ICON_SEARCH.png`" width="25" height="25"/>
      <span class="has-text-secondary">Search</span>
    </button>
  </div>
</div>
</template>

<script>
import TableFilterModal from './TableFilterModal';

export default {
  data() {
    return {
      currentFilters: {},
    };
  },
  props: {
    filters: Array,
  },
  methods: {
    showModal() {
      this.$modal.open({
        component: TableFilterModal,
        props: { filters: this.filters, initialFilters: this.currentFilters },
        events: { input: this.setFilters },
      });
    },
    removeFilter(key, value) {
      this.currentFilters[key] = this.currentFilters[key].filter(f => f.value !== value);
      this.$emit('input', this.query);
    },
    setFilters(filters) {
      this.currentFilters = filters;
      this.$emit('input', this.query);
    },
  },
  computed: {
    allFilters() {
      return Object.entries(this.currentFilters).reduce(
        (acc, [k, values]) => acc.concat(values.map(v => ({ ...v, key: k }))),
        [],
      );
    },
    query() {
      return this.allFilters.reduce((acc, f) => {
        acc[f.queryKey] = acc[f.queryKey] || [];
        acc[f.queryKey].push(f.value);
        return acc;
      }, {});
    },
  },
};
</script>

<style lang="scss" scoped>

.filters-container {
  display: flex;
  justify-content: space-between;
}


</style>
